export default "__VITE_ASSET__CL$aVbo8__"